<template>
  <v-main>
    <v-container v-if="!loading">
      <v-toolbar class="elevation-0 mb-3 b-sm-0">
        <div class="pl-0 ml-n4 d-flex align-start align-sm-center flex-column flex-sm-row">
          <span class="headline">{{ fields.name }}</span>
        </div>
        <v-spacer></v-spacer>
        <div class="d-flex mr-n4 align-center">
          <v-btn text color="primary" :to="{ name: 'fundraisingFormEdit', params: { id } }">
            <v-icon left>mdi-pencil</v-icon> Editar Arrecadação
          </v-btn>
          <v-menu offset-y v-if="isBackoffice">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" text color="primary">
                <v-icon left>mdi-file-import</v-icon> Importação <v-icon right>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="openImportDialog = true">
                <v-list-item-content>
                  <v-list-item-title><v-icon left>mdi-account-multiple-plus</v-icon> Importar formandos</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="openImportPaidDialog = true">
                <v-list-item-content>
                  <v-list-item-title><v-icon left>mdi-cash-plus</v-icon> Adicionar valores pagos</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn text color="primary" @click="openDialog = true">
            <v-icon left>mdi-file-excel-outline</v-icon> Exportar Totalizadores
          </v-btn>
          <v-btn text color="primary" :to="{ name: 'fundraisingPrint', params: { id } }">
            <v-icon left>mdi-printer</v-icon> Imprimir Relatório
          </v-btn>
        </div>
      </v-toolbar>
      <div class="d-flex justify-start align-start flex-column flex-sm-row">
        <div v-if="fields.image" class="my-3 mr-3">
          <img :src="fields.image" class="preview-image" />
        </div>
        <div class="mr-auto">
          <div class="d-flex no-wrap">
            <div>
              <small>Valor por pessoa</small>
              <br>
              <b>{{ fields.unit_price | price }}</b>
            </div>
            <div class="ml-5">
              <small>Inicia em</small>
              <br>
              <b>{{ fields.start_date | moment('MM/YYYY') }}</b>
            </div>
            <div class="ml-5">
              <small>Termina em</small>
              <br>
              <b>{{ fields.finish_date | moment('MM/YYYY') }}</b>
            </div>
          </div>
          <small>Descrição</small>
          <div v-html="fields.description"></div>
        </div>
        <div>
          <div class="no-wrap mt-4 mt-sm-0 ml-sm-5">
            <small>Meta geral</small>
            <br>
            <span class="title">{{ fields.goal | price }}</span>
          </div>
          <div class="d-flex no-wrap mt-4 mt-sm-0">
            <div class="ml-sm-5">
              <small>Total Pago</small>
              <br>
              <span class="title">{{ fields.total_paid | price }}</span>
            </div>
            <div class="ml-5">
              <small>Total Atrasado</small>
              <br>
              <span class="title">{{ fields.total_late | price }}</span>
            </div>
          </div>
        </div>
      </div>
      <br>
      <fundraising-details-participants :fundraisingId="id" :celebrationId="celebrationId" :payment-methods="fields.resources.payment_methods" :all-items="all_items" @edited="getData()"></fundraising-details-participants>
    </v-container>
    <app-loading :visible="loading"></app-loading>
    <excel-fundraising-dialog :visible="openDialog" :fundraisings="[id]" @close="openDialog = false"></excel-fundraising-dialog>
    <CsvImportFundraisingDialog
      :visible="openImportDialog"
      :celebration-id="celebrationId"
      :fundraising-id="id"
      @close="openImportDialog = false"
      @imported="getData()"
    />
    <CsvImportPaidValuesDialog
      :visible="openImportPaidDialog"
      :celebration-id="celebrationId"
      @close="openImportPaidDialog = false"
      @imported="getData()"
    />
  </v-main>
</template>

<script>
import axios from 'axios'
import { mapMutations, mapGetters } from 'vuex'
import AppLoading from '@/components/Loading'
import FundraisingDetailsParticipants from '@/components/FundraisingDetailsParticipants'
import ExcelFundraisingDialog from '@/components/ExcelFundraisingDialog'

export default {
  name: 'fundraisingForm',
  components: {
    AppLoading,
    FundraisingDetailsParticipants,
    ExcelFundraisingDialog,
    CsvImportFundraisingDialog: () => import('@/components/CSVImportFundraisingDialog'),
    CsvImportPaidValuesDialog: () => import('@/components/CSVImportPaidValuesDialog')
  },
  props: ['id', 'celebrationId'],
  data: () => ({
    loading: false,
    openDialog: false,
    openImportDialog: false,
    openImportPaidDialog: false,
    fields: {
      name: '',
      description: '',
      image: null,
      start_date: '',
      finish_date: '',
      unit_price: 0,
      people_quantity: 0,
      goal: 0,
      total_late: 0,
      total_paid: 0,
      participants: [],
      resources: {}
    }
  }),
  computed: {
    ...mapGetters(['isBackoffice']),
    all_items () {
      return this.fields.participants.map(e => {
        return { id: this.id, ...e }
      })
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    getData () {
      let vue = this
      vue.loading = true

      axios.get('fundraisings/' + vue.id)
        .then(response => {
          if (response.data) {
            vue.loading = false
            for (let key in vue.fields) {
              if (response.data[key]) vue.fields[key] = response.data[key]
            }
          } else {
            vue.loading = false
            vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
            vue.$router.go(-1)
          }
        })
        .catch(() => {
          vue.loading = false
          vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
          vue.$router.go(-1)
        })
    }
  },
  created () {
    if (this.id) {
      this.getData()
    }
  }
}
</script>
